'use client'

import { Button } from '@algoacademy/design-system/web/actions/Button'
import { PlusIcon } from '@heroicons/react/24/solid'
import { useParams } from 'next/navigation'

type ManageButtonsProps = {
  userCanManageCollection: boolean
}

export function ManageButtons({ userCanManageCollection }: ManageButtonsProps) {
  const { collectionSlug } = useParams<{ collectionSlug: string }>()

  return (
    userCanManageCollection && (
      <div className='fixed bottom-4 z-50 w-60 pl-4'>
        <div className='space-y-2'>
          <Button href={`/baza/${collectionSlug}/manage`} className='w-full'>
            <PlusIcon />
            Dodaj nowy artykuł
          </Button>
          <Button outline href='/baza/manage' className='w-full'>
            Zarządzaj kolekcjami
          </Button>
        </div>
      </div>
    )
  )
}
